import * as React from 'react'
import * as ReactDOM from 'react-dom'
import browserHistory from 'common/browserHistory'
import { HIDE_COOKIE_BANNER_FLAG } from 'common/constants'
import { matchPath } from 'react-router'
import { CookieBannerContainer } from 'components/CookieBanner'
import { scrollToAnchorHack } from 'lib/scrollToAnchorHack'
import { getCookieGDPRFlags } from 'lib/CookieGDPR/getCookieGDPRFlags'

const COOKIE_BANNER_ID = '[data-id=show-cookie-banner]'

const checkIfDOMReady = (): boolean => document.readyState === 'complete'

const checkIfPrivacyNoticePage = (): boolean => {
  const match = matchPath(browserHistory.location.pathname, {
    path: '/:locale/privacy-notice',
    exact: true
  })

  return Boolean(match)
}

const checkIfHideConsentParam = (): boolean => {
  const params = new URLSearchParams(browserHistory.location.search)
  return Boolean(params.get(HIDE_COOKIE_BANNER_FLAG))
}

const renderCookieBanner = (): void => {
  const cookieBannerId = 'cookieBanner'
  const cookieBanner = document.createElement('div')
  cookieBanner.setAttribute('id', cookieBannerId)
  document.body.append(cookieBanner)

  ReactDOM.render(<CookieBannerContainer />, cookieBanner)
}

const onClick = (event: Event): void => {
  if (event) {
    event.preventDefault()
  }

  renderCookieBanner()
}

const setEvent = (): void => {
  const elements = document.querySelectorAll(COOKIE_BANNER_ID)

  if (elements) {
    for (let i = 0; i < elements.length; i++) {
      elements[i].addEventListener('click', onClick)
    }
  }
}

const setEventsOrRender = async (disabledByDefault: boolean): Promise<void> => {
  scrollToAnchorHack()
  setEvent()

  if (disabledByDefault) {
    return
  }

  const { shouldShowCookieBanner } = await getCookieGDPRFlags()

  if (shouldShowCookieBanner) {
    renderCookieBanner()
  }
}

const documentLoadListener = (): void => {
  if (checkIfDOMReady()) {
    document.removeEventListener('readystatechange', documentLoadListener)

    setEventsOrRender(checkIfPrivacyNoticePage() && checkIfHideConsentParam())
  }
}

export const attachGDPREvent = async (): Promise<void> => {
  const { isCookieBannerAvailable } = await getCookieGDPRFlags()

  if (!isCookieBannerAvailable) {
    return
  }

  if (checkIfDOMReady()) {
    return setEventsOrRender(
      checkIfPrivacyNoticePage() && checkIfHideConsentParam()
    )
  }

  return document.addEventListener('readystatechange', documentLoadListener)
}
